

export class IntentionType
{
    static SetFormulas = "SF";
    static SetValues = "SV";
    static ClearRange = "CR";
    static DeleteGlobalName = "DGN";
    static CreateGlobalName = "CGN";
    static UnmergeRange = "UNM";
    static MergeRange = "MRG";
    static FillAndFontColor = "FFC";
    static SetFontInfo = "SFI";
    static SetFontColor = "SFIC";
    static SetFontBold = "SFIB";
    static SetFontItalic = "SFII";
    static SetHorizontalAlignment = "SHA";
    static SetVerticalAlignment = "SVA";
    static SetNumberFormat = "SNF";
    static Select = "SEL";
}
